import { useState } from 'react'
import { Link, useNavigate } from "react-router-dom"
import { useMediaQuery } from 'react-responsive'

import help_icon from "../assets/help-center-icon.png"
import notification from "../assets/notification.png"
import { HiBars3BottomRight } from "react-icons/hi2"
import { AiOutlineStar } from "react-icons/ai"
import read_icon from "../assets/read-icon.png"
import eye from "../eye.png"

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import TooltipComponent from './tooltip'
import { GET_NOTIFICATIONS, SEEN_NOTIFICATIONS, SEEN_NOTIFICATIONS_ALL, SIGN_OUT } from '../helpers/api'
import { useEffect } from 'react'

import { useSelector, useDispatch } from "react-redux";
import { loginAction } from '../redux/actions/actions';
import isUserLogin from '../helpers/IsUserLogin'



function Navbar_1() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authUser = useSelector((state) => state.authReducer)

    const [showNotify, setShowNotify] = useState(0);
    const isMobile = useMediaQuery({ query: '(max-width: 992px)' })
    const [expanded, setExpanded] = useState(false);


    return (
        <>
            <Navbar expand="lg" expanded={expanded}>
                <Container>
                    <Navbar.Brand href="/"><span style={{ color: "#8F43EE" }}>WATT</span>SHARE</Navbar.Brand>

                    <div className='d-flex ai-center'>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(expanded ? false : "expanded")} >
                            <HiBars3BottomRight className='toggler_icon' />
                        </Navbar.Toggle>

                        <div className={`hide ${isMobile ? "d-block" : "d-none"}`}>
                            <Link to="/favourites">
                                <TooltipComponent className="" placement="bottom" tooltipText="Favourite">
                                    <span><AiOutlineStar className='nav_icons favourite_icon me-3' /></span>
                                </TooltipComponent>
                            </Link>
                            <Link to="/help-center">
                                <TooltipComponent className="" placement="bottom" tooltipText="Help">
                                    <img src={help_icon} alt="icon" className='img-fluid nav_icons' />
                                </TooltipComponent>
                            </Link>
                            <TooltipComponent className="" placement="bottom" tooltipText="Notification">
                                <span><Notification showNotify={showNotify} setShowNotify={setShowNotify} /></span>
                            </TooltipComponent>
                            <Link to="/help-center" className="mx-3">
                                <TooltipComponent className="" placement="bottom" tooltipText="Help">
                                    <img src={help_icon} alt="icon" className='img-fluid nav_icons' />
                                </TooltipComponent>
                            </Link>
                        </div>

                        <div className="button diplay hide">
                            <div className="dropdown connect-dropdown">
                                <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {/* {authUser.username} */}
                                    Usama Khan
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <Link className="dropdown-item" to="/wallet">Wallet</Link>
                                    <Link className="dropdown-item" to="/profile">Profile</Link>
                                    <span className="dropdown-item" to="#" onClick={() => { SIGN_OUT(); navigate("/sign-in"); dispatch(loginAction({})) }} style={{ cursor: "pointer" }}>Sign Out</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Navbar.Collapse className='jc-center' id="basic-navbar-nav">
                        <Nav className="mb-2 mb-lg-0">
                            <li className="nav-item" onClick={() => setExpanded(false)} >
                                <Link className="nav-link active" to="/marketplace">Marketplace</Link>
                            </li>
                            <li className="nav-item" onClick={() => setExpanded(false)} >
                                <Link className="nav-link active" to="/">Dashboard</Link>
                            </li>
                            <li className="nav-item" onClick={() => setExpanded(false)} >
                                <Link className="nav-link active" to="/transaction">Transaction</Link>
                            </li>
                        </Nav>
                    </Navbar.Collapse>

                    <div className="button d-flex ai-center connect_btn_2">
                        <div>
                            <Link to="/favourites">
                                <TooltipComponent className="" placement="bottom" tooltipText="Favourite">
                                    <span><AiOutlineStar className='nav_icons favourite_icon me-3' /></span>
                                </TooltipComponent>
                            </Link>
                            {/* <Link to="/help-center">
                                <TooltipComponent className="" placement="bottom" tooltipText="Help">
                                    <img src={help_icon} alt="icon" className='img-fluid nav_icons' />
                                </TooltipComponent>
                            </Link> */}
                            <Notification showNotify={showNotify} setShowNotify={setShowNotify} />
                            <Link to="/help-center" className='mx-3'>
                                <TooltipComponent className="" placement="bottom" tooltipText="Help">
                                    <img src={help_icon} alt="icon" className='img-fluid nav_icons' />
                                </TooltipComponent>
                            </Link>
                        </div>
                        <div className="dropdown connect-dropdown">
                            <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {/* {authUser.username} */}
                                Usama Khan
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <Link className="dropdown-item" to="/wallet">Wallet</Link>
                                <Link className="dropdown-item" to="/profile">Profile</Link>
                                <span className="dropdown-item" to="#">Sign Out</span>
                            </div>
                        </div>
                    </div>
                </Container>
            </Navbar>
        </>
    )
}

function Notification(props) {

    const isMobile = useMediaQuery({ query: '(max-width: 482px)' })

    const [notifications, setNotification] = useState([
        {
            msg: "setNotification",
            timestamp: "123456799"
        },
        {
            msg: "setNotification",
            timestamp: "123456799"
        },
        {
            msg: "setNotification",
            timestamp: "123456799"
        },
        {
            msg: "setNotification",
            timestamp: "123456799"
        },
        {
            msg: "setNotification",
            timestamp: "123456799"
        },
        {
            msg: "setNotification",
            timestamp: "123456799"
        },
        {
            msg: "setNotification",
            timestamp: "123456799"
        },
        {
            msg: "setNotification",
            timestamp: "123456799"
        }

    ])


    const get_notifications = async () => {
        try {
            const response = await GET_NOTIFICATIONS()
            console.log(response);
            setNotification(response.message)
        }
        catch (e) {
            console.log(e);
        }
    }

    const seen = async (notifid) => {
        try {
            const response = await SEEN_NOTIFICATIONS({ notifid: notifid })
            get_notifications()
        }
        catch (e) {
            console.log(e);
        }
    }


    const seenall = async () => {
        try {
            const response = await SEEN_NOTIFICATIONS_ALL()
            get_notifications()
        }
        catch (e) {
            console.log(e);
        }
    }


    useEffect(() => {
        get_notifications()
    }, [])


    function dateconversion(dateStr) {
        // const dateStr = "29 Mar 2023 10:26:31 GMT";
        const date = new Date(dateStr);
        const formattedDate = date.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
        const dateArray = formattedDate.toUpperCase().split(' ');
        const formattedDateString = `${dateArray[0]} ${dateArray[1]} ${dateArray[2]}`;
        // console.log(formattedDateString); // Output: "29MARCH 2023"
        return formattedDateString
    }

    return (
        <>
            <Link to="#" className='position-relative bell'>

                <div className="dropdown notify-dropdown">
                    <button className="btn dropdown-toggle p-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <TooltipComponent className="" placement="bottom" tooltipText="Notification">
                            <img src={notification} alt="icon" className={`img-fluid nav_icons ${isMobile ? "mx-1" : "mx-3"}`} />
                        </TooltipComponent>
                    </button>
                    <div className="dropdown-menu" style={{ width: "145%" }} aria-labelledby="dropdownMenuButton">
                        <div className='notificaton_sec'>
                            <div className='p-3 notificaton_header'>
                                <h5>Notifications</h5>
                            </div>

                            <div className='scroll_notification'>
                                {
                                    notifications.map((item, i) =>
                                    (
                                        <div key={i} className='notifications d-flex jc-between ai-center px-3 py-2'>
                                            <div>
                                                <p className='notifi_text mb-1'>{item?.msg}</p>
                                                <small className='notifi_time'>{dateconversion(item?.timestamp)}</small>
                                            </div>

                                            {
                                                !item?.seen && (

                                                    <div onClick={() => seen(item?._id)} className='notifi_icon d-flex ai-center d-flex ai-center text-center'>
                                                        <img src={read_icon} alt="icon" className='img-fluid' />
                                                    </div>
                                                )
                                            }
                                        </div>
                                    ))
                                }
                            </div>

                            <div className='text-center p-3 notificaton_footer'>
                                <div onClick={() => seenall()} className=''>
                                    <img src={read_icon} alt="icon" className='img-fluid w-auto h-auto me-1' />
                                    <small>Mark all as read</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




                {/* <img onClick={() => props.setShowNotify(props.showNotify == 0 ? 1 : 0)} src={notification} alt="icon" className={`img-fluid nav_icons ${isMobile ? "mx-1" : "mx-3"}`} />
                {
                    props.showNotify == 1 &&
                    <div className='notificaton_sec'>
                        <div className='d-flex jc-between ai-center p-3'>
                            <h5>Notification</h5>
                            <div>
                                <img src={read_icon} alt="icon" className='img-fluid w-auto h-auto me-1' />
                                <small>Mark as read</small>
                            </div>
                        </div>
                        <div className='notifications d-flex jc-between ai-center px-3 py-3'>
                            <div>
                                <p className='notifi_head m-0'>Example title notification!</p>
                                <p className='notifi_text mb-1'>Lorem Ipsum is simply dummy text</p>
                                <small className='notifi_time'>Jul 23, 2021 at 9:00 PM</small>
                            </div>
                            <div className='notifi_icon d-flex ai-center d-flex ai-center text-center'>
                                <img src={eye} alt="icon" className='img-fluid' />
                            </div>
                        </div>
                        <div className='notifications d-flex jc-between ai-center px-3 py-3'>
                            <div>
                                <p className='notifi_head m-0'>Example title notification!</p>
                                <p className='notifi_text mb-1'>Lorem Ipsum is simply dummy text</p>
                                <small className='notifi_time'>Jul 23, 2021 at 9:00 PM</small>
                            </div>
                            <div className='notifi_icon d-flex ai-center text-center'>
                                <img src={eye} alt="icon" className='img-fluid' />
                            </div>
                        </div>
                        <div className='notifications d-flex jc-between ai-center px-3 py-3'>
                            <div>
                                <p className='notifi_head m-0'>Example title notification!</p>
                                <p className='notifi_text mb-1'>Lorem Ipsum is simply dummy text</p>
                                <small className='notifi_time'>Jul 23, 2021 at 9:00 PM</small>
                            </div>
                            <div className='notifi_icon d-flex ai-center text-center'>
                                <img src={eye} alt="icon" className='img-fluid' />
                            </div>
                        </div>
                        <div className='text-center p-3'>
                            <p className='notifi_head m-0'>Clear all notifications</p>
                        </div>
                    </div>
                } */}


                {/* <div className='notificaton_sec'>
                    <div className='d-flex jc-between ai-center p-3'>
                        <h5>Notification</h5>
                        <div>
                            <img src={read_icon} alt="icon" className='img-fluid w-auto h-auto me-1' />
                            <small>Mark as read</small>
                        </div>
                    </div>
                    <div className='notifications d-flex jc-between ai-center px-3 py-3'>
                        <div>
                            <p className='notifi_head m-0'>Example title notification!</p>
                            <p className='notifi_text mb-1'>Lorem Ipsum is simply dummy text</p>
                            <small className='notifi_time'>Jul 23, 2021 at 9:00 PM</small>
                        </div>
                        <div className='notifi_icon d-flex ai-center d-flex ai-center text-center'>
                            <img src={eye} alt="icon" className='img-fluid' />
                        </div>
                    </div>
                    <div className='notifications d-flex jc-between ai-center px-3 py-3'>
                        <div>
                            <p className='notifi_head m-0'>Example title notification!</p>
                            <p className='notifi_text mb-1'>Lorem Ipsum is simply dummy text</p>
                            <small className='notifi_time'>Jul 23, 2021 at 9:00 PM</small>
                        </div>
                        <div className='notifi_icon d-flex ai-center text-center'>
                            <img src={eye} alt="icon" className='img-fluid' />
                        </div>
                    </div>
                    <div className='notifications d-flex jc-between ai-center px-3 py-3'>
                        <div>
                            <p className='notifi_head m-0'>Example title notification!</p>
                            <p className='notifi_text mb-1'>Lorem Ipsum is simply dummy text</p>
                            <small className='notifi_time'>Jul 23, 2021 at 9:00 PM</small>
                        </div>
                        <div className='notifi_icon d-flex ai-center text-center'>
                            <img src={eye} alt="icon" className='img-fluid' />
                        </div>
                    </div>
                    <div className='text-center p-3'>
                        <p className='notifi_head m-0'>Clear all notifications</p>
                    </div>
                </div> */}

            </Link>
        </>
    )
}

export default Navbar_1
